export const ROUTE_STROKE_WIDTH = 8;
export const ROUTE_SELECTED_STROKE_WIDTH = 9;
export const ROUTE_SELECTED_BORDER_WIDTH = 16;
export const ROUTE_SELECTED_CASING_COLOR = "#6b7280";
// Dash lengths are screen pixels: non-scaling-stroke keeps the pattern constant at every zoom.
export const ROUTE_SELECTED_CHAIN_COLOR = "#ffffff";
export const ROUTE_SELECTED_CHAIN_WIDTH = 2.5;
export const ROUTE_SELECTED_CHAIN_DASH = "6 6";

// The run open for reshaping, drawn as the one cable on the sheet that matters:
// "during reshape can we make the cable route more visible, now its hard to
// see". Twice its resting weight, at full strength, over a white casing that
// lifts it off the linework underneath — the plan's own drawing is what a
// 3-pixel line at 0.75 disappears into. Its HUE is untouched: that is the run's
// identity, and the announcement must not cost him it.
export const ROUTE_LIVE_STROKE_WIDTH = 18;
export const ROUTE_LIVE_CASING_WIDTH = 30;
export const ROUTE_LIVE_CASING_COLOR = "#ffffff";
export const ROUTE_LIVE_CASING_OPACITY = 0.9;
export const ROUTE_LIVE_OPACITY = 1;

// And everything else steps back while that mode is open. The existing "faded"
// pair below is 0.8/0.75 against a 0.8/0.75 normal — a fade that fades nothing
// — so a real one is spelled out here rather than by weakening a constant two
// other states read.
export const ROUTE_DIMMED_OPACITY = 0.22;

export const ROUTE_OPACITY_AT_LOW_ZOOM = 0.8;
export const ROUTE_OPACITY_AT_HIGH_ZOOM = 0.75;

export const ROUTE_FADED_OPACITY_AT_LOW_ZOOM = 0.8;
export const ROUTE_FADED_OPACITY_AT_HIGH_ZOOM = 0.75;

export const MARKER_OPACITY_AT_LOW_ZOOM = 1;
export const MARKER_OPACITY_AT_HIGH_ZOOM = 0.4;

export const HANDLE_FILL = "#ffffff";

// The estimator's own diagram of what he wanted, and the spec for all three:
//
//     ◯ ——— ⊕ ——— ◯      ◯ a corner, drag it
//           ⊗            ⊕ add a corner here
//                        ⊗ delete this length
//
// They are told apart by SHAPE and by two glyphs everyone on a drawing already
// reads — the palette spends twelve hues per circuit, so no colour is free to
// carry meaning, and the one colour used here is red, for the one mark that
// takes something away.
//
// **EVERY number below is DEVICE PIXELS, and is divided by `zoomLevel` before
// it is drawn.** A grab handle is a screen-space object. Expressed in plan
// units, a handle grows with the drawing at exactly the rate the gap between
// two corners grows, so two corners that overlap at 1× overlap identically at
// 8× and cannot be separated at any zoom: "its really hard or even impossible
// to connect these 2 white dots together". Counter-scaled, zooming in is the
// natural remedy — the geometry spreads and the handles do not.

// A corner is a SQUARE, and that is the whole point of it: "from this view its
// different to understand which is joint point which is device". It was a
// filled white disc sitting on the same coloured cable as the run's own device
// markers — two round marks a few pixels apart meaning a bend he may drag and a
// piece of equipment that gets billed.
//
// SHAPE is the only free axis. Colour is spent: the palette is per-run and
// carries which circuit he is looking at, so a corner cannot take a hue without
// lying about the run. Size is spent too: handles are screen-space constants
// and shrinking one makes it harder to hit, which is the bug before this one.
// A square against a disc separates at a glance, survives dense linework, and
// is the convention every drawing tool already uses for a vertex.
//
// The plan's only other square — the unrouted-device mark — is hollow, violet
// and WITHDRAWN whenever a circuit is isolated, which reshaping always is. So
// the two never share a sheet.
// MEASURED, not chosen. The run being reshaped is drawn 18 screen pixels wide
// over a 30-pixel WHITE casing, and the joint was a 12-pixel white square
// stroked in the run's own colour — a white mark inside a wider white mark. It
// was on the drawing and could not be seen: "interactivity with joint (white
// points on routes) are not there".
//
// So the handle is wider than the casing it sits on, and it is outlined in ink
// rather than in the run's hue, because the hue has to read against the white
// casing and cannot. The fill stays white and the silhouette stays square, so
// it is still told apart from a device at a glance.
export const NODE_RADIUS_PX = 9;
export const NODE_HOVER_RADIUS_PX = 12;
export const NODE_HANDLE_STROKE_WIDTH = 2.5;
export const NODE_HANDLE_HOVER_STROKE_WIDTH = 4;
/** Ink, so the handle reads on the white casing AND on the coloured cable. */
export const NODE_HANDLE_STROKE = "#111827";

// How far a glyph's arms reach inside the disc that carries it.
export const GLYPH_ARM_RATIO = 0.5;

// What each mark REACHES, on screen. Every one is at least as big as the mark
// it belongs to, so nothing is drawn that cannot be clicked.
export const NODE_HIT_PX = 14;

// What a node reaches WHILE HE IS DRAWING, and it is deliberately far larger
// than the click target it has at rest.
//
// "i just want to connect this two sources, why drawing an edge is toooooo
// fucking hard?" — a device is a disc of Ø40px at 1× and Ø160px at 4×, and the
// square buried in it had a Ø22px target that never grew. Zooming in, the
// obvious response to missing, made the target a SMALLER fraction of the thing
// he was aiming at: 30% of the disc's area at 1×, 2% at 4×.
//
// Once a stroke is open and the cursor is anywhere near a node, the intent is
// unambiguous — there is nothing else he could mean — so the target is sized
// for the intent rather than for the mark.
export const DRAW_LANDING_HIT_PX = 30;

// And the candidate says so: a ring around whatever the click would land on,
// wider than a device's own disc at working zoom so it reads on top of one.
export const LANDING_RING_PX = 24;

// A SIGN: a small round button that appears beside the thing he clicked and is
// the only thing that acts. "if in reshaping mode i click on a node (device) it
// opens small sign for adding/drawing new edge from this node... same for
// removing edge, i click on edge it become red opens small remove sign there i
// clik and edge is removed. thats it"
//
// It is drawn as a control and not as another abstract mark: a filled disc with
// a glyph, big enough to be an obvious target, offset clear of the thing it
// acts on so it never hides it.
// MEASURED against what it hangs off. A device is a disc of radius 28 on the
// sheet, and the sign was a disc of radius 11 sitting 37 away from its centre —
// so the button was less than half the size of the symbol and its edge fell
// INSIDE the symbol's own. It read as a speck on the device, not as a control:
// "what does this + i click it does nothing".
//
// The offset now clears the device disc outright, and the button is the size of
// a thing meant to be pressed.
export const SIGN_RADIUS_PX = 14;
export const SIGN_HIT_PX = 18;
export const SIGN_OFFSET_PX = 52;
export const SIGN_GAP_PX = 34;
export const SIGN_STROKE_WIDTH = 2;
export const SIGN_GLYPH_STROKE_WIDTH = 2.5;
export const LANDING_RING_STROKE_WIDTH = 3;
// Every node he could finish the cable on, while he is drawing. Dashed and
// stepped back so the ring under the cursor is still the loud one — this is an
// offer of where it MAY go, not a claim about where it will.
// What a joint in his hand would WELD to. Ink, because it lands on a cable in
// the run's own colour over a white casing on a white sheet — the hue it is
// drawn in is the one colour that cannot say anything there.
export const JOIN_TARGET_STROKE_WIDTH = 5;
export const JOIN_TARGET_DASH = "9 7";
export const JOIN_TARGET_OPACITY = 0.95;

export const LANDING_OFFER_DASH = "5 5";
export const LANDING_OFFER_OPACITY = 0.55;
export const EDGE_HIT_PX = 7;

// Red, and deliberately the same red the plan already spends on a struck
// device: on this drawing red means "this one goes".
export const DELETE_COLOR = "#dc2626";

// The hairline from a sign back to the thing it acts on. It carries no verb:
// it exists so there is never a question which length or which node the button
// beside it belongs to.
export const SIGN_LEADER_STROKE_WIDTH = 1.5;
export const SIGN_LEADER_DASH = "2 3";

// The length he clicked, reddened from corner to corner. Red is the WARNING,
// not the act: it says this is the one that goes if he clicks the ✕ beside it.
export const SELECTED_EDGE_STROKE_WIDTH = 14;
export const SELECTED_EDGE_OPACITY = 0.55;

// A length no device's cable runs through. Drawn, measured nowhere — so it is
// dashed in the run's own colour rather than solid, and the difference between
// "cable" and "line I drew that feeds nothing" is on the drawing.
export const STRANDED_STROKE_WIDTH = 4;
export const STRANDED_DASH = "6 6";

// The cable the second click will make, dashed until he commits it.
export const PREVIEW_STROKE_WIDTH = 5;
export const PREVIEW_DASH = "10 6";

// A device the edit has cut off from the board. It is not removed — he cuts and
// then redraws, and the question is only asked on the way out — so it is marked
// rather than struck.
export const DOOMED_DEVICE_RADIUS_RATIO = 0.36;
export const DOOMED_DEVICE_STROKE_WIDTH = 3;

/** A feeder is a heavier cable than any circuit, and it reads as one: weight, not a new colour. */
export const FEEDER_STROKE_FACTOR = 1.8;
